(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gs-swipe-hint"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__gsSwipe) return;
    window.__gsSwipe = true;
    function stop(e) { if (e.target.closest && e.target.closest('.gs-swipe')) { e.stopPropagation(); } }
    ['pointerdown', 'pointerup', 'mousedown', 'touchstart'].forEach(function (t) { document.addEventListener(t, stop, true); });
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.gs-swipe');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      var g = btn.closest('.card-gallery');
      var ss = g && g.querySelector('slideshow-component');
      if (!ss) return;
      if (typeof ss.next === 'function') { ss.next(); return; }
      var nb = ss.querySelector('.slideshow-control--next, [aria-label*="ext"], [on\\:click*="next"]');
      if (nb) nb.click();
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
